import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const ENDPOINT_OVERVIEW_STATS = 'https://europe-west2-gmsm-adapter.cloudfunctions.net/adapterOverviewStats';

export const types = {
  GET_SHOW_LOADER: 'GET_SHOW_LOADER',
  GET_SELLERS: 'GET_SELLERS',
  GET_SELECTED_SELLER: 'GET_SELECTED_SELLER',
  GET_TOKEN: 'GET_TOKEN',
  GET_IS_TOKEN_VALID: 'GET_IS_TOKEN_VALID',

  MUTATION_SET_LOADER_STATUS: 'MUTATION_SET_LOADER_STATUS',
  MUTATION_SET_SELLERS_DATA: 'MUTATION_SET_SELLERS_DATA',
  MUTATION_SAVE_SELECTED_SELLER: 'MUTATION_SAVE_SELECTED_SELLER',
  MUTATION_SAVE_TOKEN: 'MUTATION_SAVE_TOKEN',
  MUTATION_TOGGLE_TOKEN_VALID: 'MUTATION_TOGGLE_TOKEN_VALID',

  FETCH_OVERVIEW_STATS: 'FETCH_OVERVIEW_STATS',
  SET_SELECTED_SELLER: 'SET_SELECTED_SELLER',
  FETCH_INITIAL_DATA: 'FETCH_INITIAL_DATA',
};

export default new Vuex.Store({
  state: {
    showLoader: true,
    sellers: [],
    selectedSeller: '',
    token: null,
    isTokenValid: false,
  },
  getters: {
    [types.GET_TOKEN]: state => state.token,
    [types.GET_IS_TOKEN_VALID]: state => state.isTokenValid,
    [types.GET_SHOW_LOADER]: state => state.showLoader,
    [types.GET_SELLERS]: state => state.sellers,
    [types.GET_SELECTED_SELLER]:
      state => state.sellers
        .filter(item => item.seller === state.selectedSeller)
        .sort((a, b) => new Date(a.date.value).getTime() - new Date(b.date.value).getTime()),
  },
  mutations: {
    [types.MUTATION_SET_LOADER_STATUS](state, status) {
      state.showLoader = status;
    },
    [types.MUTATION_SET_SELLERS_DATA](state, data) {
      state.sellers = data;
    },
    [types.MUTATION_SAVE_SELECTED_SELLER](state, data) {
      state.selectedSeller = data;
    },
    [types.MUTATION_SAVE_TOKEN](state, token) {
      localStorage.setItem('gmsm-auth-token', JSON.stringify(token));
      state.token = token;
    },
    [types.MUTATION_TOGGLE_TOKEN_VALID](state, status) {
      state.isTokenValid = status;
    },
  },
  actions: {
    [types.SET_SELECTED_SELLER]({ commit }, seller) {
      commit(types.MUTATION_SAVE_SELECTED_SELLER, seller);
    },
    async [types.FETCH_OVERVIEW_STATS]({ commit, getters }) {
      commit(types.MUTATION_SET_LOADER_STATUS, true);

      try {
        const response = await fetch(ENDPOINT_OVERVIEW_STATS, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${getters[types.GET_TOKEN]}`,
          },
        });

        if (response.status === 403) {
          commit(types.MUTATION_TOGGLE_TOKEN_VALID, false);
        } else {
          const { result } = await response.json();

          commit(types.MUTATION_SET_SELLERS_DATA, result);
          commit(types.MUTATION_TOGGLE_TOKEN_VALID, true);
        }
      } catch (e) {
        commit(types.MUTATION_TOGGLE_TOKEN_VALID, false);
      } finally {
        commit(types.MUTATION_SET_LOADER_STATUS, false);
      }
    },
    [types.FETCH_INITIAL_DATA]({ commit, dispatch }, queryToken) {
      try {
        const token = queryToken || JSON.parse(localStorage.getItem('gmsm-auth-token'));

        if (token) {
          commit(types.MUTATION_SAVE_TOKEN, token);
          dispatch(types.FETCH_OVERVIEW_STATS);
        } else {
          commit(types.MUTATION_SET_LOADER_STATUS, false);
        }
      } catch (e) {
        commit(types.MUTATION_SET_LOADER_STATUS, false);
      }
    },
  },
});
